import isEmpty from 'lodash/isEmpty'
import { appSettings } from '../../../../config/app-settings'
import type { Payment } from '@ztechapps/common.contract'

export type StripeInfo = {
  stripeInfoUrl: string
  hasPaymentInfo: boolean
}

export type PaymentWithStripeInfo = Payment & StripeInfo

export const getOtherStripeInfos = ({ payment }): StripeInfo => {
  const paymentIntent = payment?.stripeInfo?.paymentIntent

  const stripeInfoUrl = paymentIntent ? `${appSettings?.Stripe?.rootUrl}payments/${paymentIntent}` : undefined
  const hasPaymentInfo = !isEmpty(paymentIntent)

  return {
    stripeInfoUrl,
    hasPaymentInfo,
  }
}
